import React, { useMemo } from 'react';

import AuthGuardContext from './AuthGuardContext.js';
import useAuthGuard from './useAuthGuard.js';

export type AuthGuardProviderProps = ReturnType<typeof useAuthGuard> & {
  children: React.ReactNode;
};

/**
 * Defines the context for the AuthGuard
 */
export const AuthGuardProvider: React.FC<AuthGuardProviderProps> = ({ children, hasScope }) => {
  return (
    <AuthGuardContext.Provider value={useMemo(() => ({ hasScope }), [hasScope])}>
      {children}
    </AuthGuardContext.Provider>
  );
};
